import React from "react";
import { Form, Input, Row, Col } from "antd";
import { validateName, phoneValidator } from "../../../../utils/validator";

const { TextArea } = Input;

const EmergencyContactSection = () => {
  return (
    <div className="p-5">
      <Row gutter={[16, 16]}>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item
            name="emergencyContactFirstName"
            label="First Name"
            rules={[{ validator: validateName }]}
          >
            <Input placeholder="Enter First Name" />
          </Form.Item>
        </Col>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item
            name="emergencyContactLastName"
            label="Last Name"
            rules={[{ validator: validateName }]}
          >
            <Input placeholder="Enter Last Name" maxLength={30} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item
            name="emergencyContactPhone"
            label="Phone Number"
            rules={[{ validator: phoneValidator }]}
          >
            <Input placeholder="Enter Phone Number" maxLength={20} />
          </Form.Item>
        </Col>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item
            name="relationship"
            label="Relationship with Patient"
          >
            <Input placeholder="Enter Relationship" maxLength={30} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12} sm={24} md={12} lg={12}>
          <Form.Item name="emergency_contact_notes" label="Notes">
            <TextArea showCount maxLength={300} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(EmergencyContactSection);
